import { render, staticRenderFns } from "./imageViewer.vue?vue&type=template&id=79d9aeb9&scoped=true"
import script from "./imageViewer.vue?vue&type=script&lang=js"
export * from "./imageViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d9aeb9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79d9aeb9')) {
      api.createRecord('79d9aeb9', component.options)
    } else {
      api.reload('79d9aeb9', component.options)
    }
    module.hot.accept("./imageViewer.vue?vue&type=template&id=79d9aeb9&scoped=true", function () {
      api.rerender('79d9aeb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/imageViewer.vue"
export default component.exports